import { END_POINTS } from '../helpers';
import { CommonBody, Packages } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetPackagesResponse = {
  totalCount: number;
  list: Packages[];
};

export const packageApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPackage: builder.query<
      CommonResponse & { data: GetPackagesResponse },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.getPackage}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }`,
        method: 'GET',
      }),
    }),

    deletePackage: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deletePackage}/${id}`,
        method: 'DELETE',
      }),
    }),
    getPackageById: builder.query<CommonResponse & { data: Packages }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getPackageById}/${id}`,
        method: 'GET',
      }),
    }),

    addPackage: builder.mutation<CommonResponse & { data: Packages }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addPackage}`,
        method: 'POST',
        body,
      }),
    }),
    updatePackage: builder.mutation<
      CommonResponse & { data: Packages },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updatePackage}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddPackageMutation,
  useUpdatePackageMutation,
  useLazyGetPackageQuery,
  useLazyDeletePackageQuery,
  useLazyGetPackageByIdQuery,
} = packageApi;
